import React from 'react'

import {
  ChoiceGroupBorder,
  RadioInput,
  RadioLabel,
  RadioOptionRow,
} from './BookingQuestion.styled'

import {Select, Option} from '~/components/general/select/Select'

type Choice = {id: string; label: string}

type Props = {
  choices: Choice[]
  selectedId?: string
  name: string
  required?: boolean
  onChange: (choiceId: string) => void
}

export const BookingChoiceInput: React.FC<Props> = ({
  choices,
  selectedId,
  name,
  required,
  onChange,
}) => {
  const selected = choices.find((c) => c.id === selectedId)
  const totalLabelsLength = choices.reduce(
    (sum, c) => sum + (c.label ? c.label.length : 0),
    0,
  )

  if (totalLabelsLength < 100) {
    return (
      <ChoiceGroupBorder flex wrap spacing={1} required={!!required}>
        {choices.map((c) => (
          <RadioOptionRow key={c.id} flex>
            <RadioInput
              id={`${name}-${c.id}`}
              name={name}
              checked={c.id === selectedId}
              onChange={() => onChange(c.id)}
            />
            <RadioLabel htmlFor={`${name}-${c.id}`}>{c.label}</RadioLabel>
          </RadioOptionRow>
        ))}
      </ChoiceGroupBorder>
    )
  }

  return (
    <Select
      value={selected?.label || ''}
      onChange={() => undefined}
      selectedOption={selected?.label}
      required={!!required}>
      {choices.map((c) => (
        <Option key={c.id} onClick={() => onChange(c.id)}>
          {c.label}
        </Option>
      ))}
    </Select>
  )
}
